import { HttpHandler } from 'msw'

import { restartComputer } from './restartComputer'

export const restart: HttpHandler[] = [restartComputer]
